import React from 'react';
import { Tag } from '@wfp/ui';

import { type Country, Topic } from '../../restapi/types';

interface SimpleSection {
	title: string,
	subtitle: string,
	content: string,
	topic?: Topic,
	countries?: Country[],
	tags?: string[],
}

interface Props {
	section: SimpleSection;
}


export function SectionView(props: Props) {
	const {section: sec} = props;

	const showContentOnly = sec.topic === Topic.highlights;

	return (
		<div className="dedob-document edit mb-0">
			{!showContentOnly && (
				<>
					<h4 className="color-primary">{sec.title}</h4>
					<p>{sec.subtitle}</p>

					{(sec.countries || []).map(c => <Tag key={c.pk} type="info">{c.name}</Tag>)}

					{(sec.tags || []).map(t => <Tag key={t} type="info">{t}</Tag>)}
				</>)
			}

			<div dangerouslySetInnerHTML={{__html: sec.content}}/>
		</div>
	);
}